export default __webpack_public_path__ + "static/media/video.79cdf96a.mp4";